export default __webpack_public_path__ + "static/media/google.9a7800d0.svg";